import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToPlainFormat } from '@/utils'

export interface SystemUserLink {
  id: number
  processedTime: string
  processedBranchCode: SystemCode
  processedPlaceCode: SystemCode
  processedIpAddress: string
  title: string
  url: string
  revision: number
}

export const defaultSystemUserLink = (): SystemUserLink => ({
  id: 0,
  processedTime: '',
  processedBranchCode: defaultSystemCode(),
  processedPlaceCode: defaultSystemCode(),
  processedIpAddress: '',
  title: '',
  url: '',
  revision: 0
})

export function SystemUserLinkFromJSON(json: any): SystemUserLink {
  return {
    id: exists(json, 'id') ? json.id : 0,
    processedTime: exists(json, 'processed_time')
      ? dateTimeToPlainFormat(json.processed_time)
      : '',
    processedBranchCode: exists(json, 'processed_branch_code')
      ? SystemCodeFromJSON(json.processed_branch_code)
      : defaultSystemCode(),
    processedPlaceCode: exists(json, 'processed_place_code')
      ? SystemCodeFromJSON(json.processed_place_code)
      : defaultSystemCode(),
    processedIpAddress: exists(json, 'processed_ip_address')
      ? json.processed_ip_address
      : '',
    title: exists(json, 'title') ? json.title : '',
    url: exists(json, 'url') ? json.url : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
